import ReactDOM from 'react-dom';

const root = document.querySelector('#root-modal');
const Portal = ({ children }) => ReactDOM.createPortal(children, root);
export default Portal;



// WEBPACK FOOTER //
// ./src/uic/Portal.js